"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.decorator = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _draftJs = require("draft-js");
var _Link = _interopRequireDefault(require("./Link"));
var _linkStrategy = _interopRequireDefault(require("./linkStrategy"));
var _EditorUtils = _interopRequireDefault(require("../EditorUtils"));
var _getSelectionEntities = _interopRequireDefault(require("../getSelectionEntities"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getSelectionLink = editorState => {
  // Return entity when one and only one selected
  return (0, _getSelectionEntities.default)(editorState, 'LINK').last();
};
class LinkControls extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInput: false,
      href: '',
      target: '_self'
    };
  }
  componentWillReceiveProps(nextProps) {
    const editorState = nextProps.editorState;
    if (editorState !== this.props.editorState) {
      const entityLink = getSelectionLink(this.props.editorState);
      const nextEntityLink = getSelectionLink(editorState);
      if (nextEntityLink && nextEntityLink !== entityLink) {
        const entityInstance = _draftJs.Entity.get(nextEntityLink.entityKey);
        const _entityInstance$getDa = entityInstance.getData(),
          href = _entityInstance$getDa.href,
          target = _entityInstance$getDa.target;
        this.setState({
          href,
          target,
          hasLink: true
        });
      } else {
        this.setState({
          href: '',
          target: '_self',
          hasLink: false
        });
      }
    }
  }
  handleToggleInput() {
    this.setState({
      showInput: !this.state.showInput
    });
  }
  confirmLink() {
    const _this$props = this.props,
      editorState = _this$props.editorState,
      setEditorState = _this$props.setEditorState;
    if (this.state.href) {
      const _this$state = this.state,
        href = _this$state.href,
        target = _this$state.target;
      setEditorState(_EditorUtils.default.toggleLink(editorState, {
        href,
        target
      }));
    } else {
      setEditorState(_EditorUtils.default.toggleLink(editorState, null));
    }
    this.setState({
      showInput: false
    });
    this.props.focusEditor();
  }
  removeLink() {
    const _this$props2 = this.props,
      editorState = _this$props2.editorState,
      setEditorState = _this$props2.setEditorState;
    setEditorState(_EditorUtils.default.toggleLink(editorState, null));
    this.props.focusEditor();
  }
  handleChangeTarget(e) {
    this.setState({
      target: e.target.checked ? '_blank' : '_self'
    });
  }
  render() {
    const _this$props3 = this.props,
      buttonClassName = _this$props3.buttonClassName,
      popoverClassName = _this$props3.popoverClassName;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "linkControls"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: (0, _classnames.default)(buttonClassName, this.state.hasLink ? 'active' : null),
      onClick: this.handleToggleInput.bind(this)
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-link"
    })), this.state.showInput && /*#__PURE__*/_react.default.createElement("div", {
      className: popoverClassName
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex flex-wrap"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "text",
      value: this.state.href,
      onChange: e => this.setState({
        href: e.target.value
      }),
      className: "input col-8 m0"
    }), /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-outline white mx1",
      onClick: this.confirmLink.bind(this)
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-check"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "flex flex-wrap mt1"
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: "targetId",
      type: "checkbox",
      onChange: this.handleChangeTarget.bind(this),
      value: this.state.target,
      checked: this.state.target === '_blank',
      "data-wysihtml5-dialog-field": "target"
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "targetId",
      style: {
        cursor: 'pointer',
        lineHeight: 'normal'
      }
    }, "Abrir link em nova aba"))), /*#__PURE__*/_react.default.createElement("button", {
      className: buttonClassName,
      onClick: this.removeLink.bind(this)
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-unlink"
    })));
  }
}
exports.default = LinkControls;
const decorator = exports.decorator = {
  strategy: _linkStrategy.default,
  component: _Link.default
};